import pagination from '@iso/lib/helpers/pagination';

const model = {
    ...pagination('promotionList').model,
};

export default model;